// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZE4Ol4OvIY {
  max-height: 250px;
  overflow-y: scroll;
}
.ZE4Ol4OvIY .b-grid-row {
  font-size: 11px;
}
.ZE4Ol4OvIY .clTgN29M9N {
  overflow-y: auto;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ticketHistory__CollapseRoot": `ZE4Ol4OvIY`,
	"ticketHistory__descriptionCell": `clTgN29M9N`
};
export default ___CSS_LOADER_EXPORT___;
